import { render } from "./MetaDataPanel.vue?vue&type=template&id=e98567de"
import script from "./MetaDataPanel.vue?vue&type=script&lang=js"
export * from "./MetaDataPanel.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__